(() => {
  const onReady = (fn) => document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);

  onReady(() => {
    const menuButton = document.querySelector('[data-menu-toggle]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    if (menuButton && mobileMenu) {
      menuButton.addEventListener('click', () => {
        const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!isOpen));
        menuButton.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
        mobileMenu.hidden = isOpen;
        document.body.classList.toggle('menu-open', !isOpen);
      });
    }

    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const jsonEl = root.querySelector('[data-product-json]');
      let variants = [];
      try {
        variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      } catch (error) {
        console.warn('Variant data unavailable.', error);
      }

      const select = root.querySelector('[data-variant-select]');
      const price = root.querySelector('[data-product-price]');
      const skuWrap = root.querySelector('.sku');
      const sku = root.querySelector('[data-product-sku]');
      const button = root.querySelector('[data-add-to-cart]');
      const label = root.querySelector('[data-add-label]');
      const mainImage = root.querySelector('.product-main-image');
      const currency = window.Shopify?.currency?.active || 'USD';

      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency
          }).format(cents / 100);
        } catch (error) {
          return `$${(cents / 100).toFixed(2)}`;
        }
      };

      const updateVariant = (variant) => {
        if (!variant) return;
        if (price) {
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          price.innerHTML = `<span class="price${onSale ? ' price--sale' : ''}"><span class="price__current">${formatMoney(variant.price)}</span>${onSale ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>` : ''}</span>`;
        }
        if (sku) sku.textContent = variant.sku || '';
        if (skuWrap) skuWrap.classList.toggle('is-hidden', !variant.sku);
        if (button) button.disabled = !variant.available;
        if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';

        const variantImage = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
        if (mainImage && variantImage) { mainImage.srcset = ''; mainImage.src = variantImage; }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      if (select) {
        select.addEventListener('change', () => {
          updateVariant(variants.find((item) => String(item.id) === select.value));
        });
      }

      const qty = root.querySelector('[data-qty-input]');
      root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
        if (qty) qty.value = Math.max(1, Number(qty.value || 1) - 1);
      });
      root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
        if (qty) qty.value = Math.max(1, Number(qty.value || 1) + 1);
      });

      root.querySelectorAll('.product-thumb').forEach((thumb) => thumb.addEventListener('click', () => {
        if (mainImage) {
          mainImage.srcset = '';
          mainImage.src = thumb.dataset.mediaSrc;
          mainImage.alt = thumb.dataset.mediaAlt || '';
        }
        root.querySelectorAll('.product-thumb').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      }));
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }), { threshold: 0.12 });
      document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    } else {
      document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
    }
  });
})();
